import widgetModel from "./widgetModel";
export default function widgetsModel(config, data) {
    let WidgetsCheck = data
        ? data
            .map((widget) => widgetModel(config, widget))
            .filter((widget) => widget !== undefined)
        : [];
    return WidgetsCheck;
}
